import { useState, useContext } from 'react'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { ProspectContext } from './../contexts/ProspectContext'
import { Form, Button } from 'react-bootstrap'
import Loader from './Loader'
import { handleCardPayment } from '../utils/payment'

const CardForm = ({ handleError, handleLoading, handleSuccess, loading }) => {
  const stripe = useStripe()
  const elements = useElements()
  const { state } = useContext(ProspectContext)
  const [complete, setComplete] = useState(false)
  const [formErrorMessage, setFormErrorMessage] = useState('')

  // Handle onChange Stripe Form validation
  const handleChange = (change) => {
    setComplete(change.complete)
    if (change.error) {
      setFormErrorMessage(change.error.message)
    } else {
      setFormErrorMessage('')
    }
  }

  // Handle Stripe Form submission
  const handleSubmit = async (evt) => {
    evt.preventDefault()

    // Prevent submission if form is incomplete, already loading, or Stripe/Elements not ready
    if (!complete || loading || !stripe || !elements) return false

    handleLoading(true)

    try {
      // Create payload fresh for each submission
      const payload = {
        PaymentMethod: 'card',
        ProspectId: state.prospect.prospectId,
        SelectedPlan: state.selectedPlan.id
      }

      const cardElement = elements.getElement(CardElement)
      const certificateUrl = await handleCardPayment(payload, stripe, cardElement)
      handleSuccess({
        completed: true,
        certificate: certificateUrl
      })
    } catch (error) {
      handleError(error)
    } finally {
      handleLoading(false)
    }
  }

  return (
    <>
      {loading && (
        <Loader loadingText='Betaling verwerken…' />
      )}
      <div className='CardForm' {...(loading ? { style: { display: 'none' } } : {})}>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Kaart details</Form.Label>
            <CardElement className='form-control' onChange={handleChange} options={createOptions()} />
            <Form.Control.Feedback type='invalid'>{formErrorMessage}</Form.Control.Feedback>
          </Form.Group>
          <Button type='submit' disabled={!complete || loading || !stripe || !elements}>
            Onderschrijven
          </Button>
        </Form>
      </div>
    </>
  )
}

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'The Sans, Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#c23d4b'
      }
    }
  }
}

export default CardForm
